export default "__VITE_ASSET__C3rQb8PR__"